import * as React from "react";
import { Box, Grid, Modal, Typography } from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import { formatToUsDate, getDateTime } from "../utils/DateHelper";
import { ImagesContext } from "../Context";

interface Props {
  showIntegrationModal: boolean;
  closeIntegrationModal: any;
  activeIntegrations: any[];
  inactiveIntegrations: any[];
}

interface StatusTileProps {
  integration: any;
}

const IntegrationStatusTile: React.FC<StatusTileProps> = ({ integration }) => {
  const images = React.useContext(ImagesContext);

  return (
    <Box className="tile-layout">
      <div
        className="item-icon-container integration-icon"
        style={{
          backgroundColor: integration.active ? "#EDF7EE" : "#F6D7D7",
        }}
      >
        <img
          src={integration.active ? images.online_icon : images.offline_icon}
          alt="Insurance Icon"
          className="action-icon-image"
          style={{ width: 23, maxHeight: 23 }}
        />
      </div>
      <Box>
        <Typography className="tile-heading">
          {integration.description}
        </Typography>
        <Typography className="tile-sub-heading">
          Last successful connection at{" "}
          {`${formatToUsDate(
            integration.last_successfully_connected_at
          )} ${getDateTime(integration.last_successfully_connected_at)}`}
        </Typography>
        <Typography className="tile-sub-heading">
          Last attempt at{" "}
          {`${formatToUsDate(integration.last_checked_at)} ${getDateTime(
            integration.last_checked_at
          )}`}
        </Typography>
      </Box>
    </Box>
  );
};

const DataSmasherNotificationTile: React.FC<StatusTileProps> = ({
  integration,
}) => {
  const images = React.useContext(ImagesContext);

  return (
    <Box className="tile-layout">
      <div
        className="item-icon-container integration-icon"
        style={{
          backgroundColor: integration.active ? "#EDF7EE" : "#F6D7D7",
        }}
      >
        <img
          src={integration.active ? images.online_icon : images.offline_icon}
          alt="Insurance Icon"
          className="action-icon-image"
          style={{ width: 23, maxHeight: 23 }}
        />
      </div>
      <Box>
        <Typography className="tile-heading">
          {integration.description}
        </Typography>
        <Typography className="tile-sub-heading">
          Cleanup Results: {integration.cleanup_results}
        </Typography>
        <Typography className="tile-sub-heading">
          Last successful cleanup at{" "}
          {`${formatToUsDate(
            integration.last_successful_cleanup_at
          )} ${getDateTime(integration.last_successful_cleanup_at)}`}
        </Typography>
      </Box>
    </Box>
  );
};

const IntegrationStatusModal: React.FC<Props> = ({
  showIntegrationModal,
  closeIntegrationModal,
  activeIntegrations,
  inactiveIntegrations,
}) => {
  return (
    <Modal
      open={showIntegrationModal}
      className="modal-primary"
      onClose={closeIntegrationModal}
    >
      <div className="paper integrations-outer-container">
        <div className="paperInner">
          <Grid container>
            <Grid item xs={12}>
              <div className="main-header integration-header">
                <span>Third Party Integration Status</span>
                <span id="dismiss-button" onClick={closeIntegrationModal}>
                  <ClearIcon sx={{ width: 30, height: 30 }} />
                </span>
              </div>
            </Grid>
            <Grid item xs={12}>
              <div className="content integration-content">
                <Box className="tiles-container">
                  {inactiveIntegrations?.map((integration) =>
                    integration.name === "Data Smasher Cleanup Results" ? (
                      <DataSmasherNotificationTile integration={integration} />
                    ) : (
                      <IntegrationStatusTile integration={integration} />
                    )
                  )}
                  {inactiveIntegrations?.length > 0 &&
                    activeIntegrations?.length > 0 && (
                      <Box className="horizontal-divider"></Box>
                    )}
                  {activeIntegrations?.map((integration) =>
                    integration.name === "Data Smasher Cleanup Results" ? (
                      <DataSmasherNotificationTile integration={integration} />
                    ) : (
                      <IntegrationStatusTile integration={integration} />
                    )
                  )}
                </Box>
              </div>
            </Grid>
          </Grid>
        </div>
      </div>
    </Modal>
  );
};

export default IntegrationStatusModal;
